export default __webpack_public_path__ + "static/media/image_placeholder.2817dae0.svg";